// Push NATIVO (app Capacitor) vía @capacitor/push-notifications. Ver CLAUDE.md §8.
// El backend envía data + bloque android.notification: en segundo plano Android
// muestra la notificación del sistema; en primer plano llega el evento y solo
// refrescamos la campanita. El tap navega a data.url (deep-link a la OT).
import { PushNotifications } from '@capacitor/push-notifications'

export async function initNativePush(
  onToken: (token: string) => void,
  onNavigate: (url: string) => void,
): Promise<void> {
  try {
    let perm = await PushNotifications.checkPermissions()
    if (perm.receive === 'prompt') perm = await PushNotifications.requestPermissions()
    if (perm.receive !== 'granted') return

    await PushNotifications.addListener('registration', (token) => onToken(token.value))
    await PushNotifications.addListener('pushNotificationReceived', (n) => {
      // App abierta: Android NO muestra la notificación del sistema en primer
      // plano — mostramos un aviso dentro de la app (PushToast) y refrescamos
      // la campanita. (Retro: "no tuve las push" probando con la app abierta.)
      window.dispatchEvent(
        new CustomEvent('ds-notification', {
          detail: {
            title: n.title ?? (n.data as Record<string, string> | undefined)?.title,
            body: n.body ?? (n.data as Record<string, string> | undefined)?.body,
            url: (n.data as Record<string, string> | undefined)?.url,
          },
        }),
      )
    })
    await PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
      const url = (action.notification.data as Record<string, string> | undefined)?.url
      if (url) onNavigate(url)
    })

    await PushNotifications.register()
  } catch {
    /* push es best-effort: nunca romper la app */
  }
}
